import { render, staticRenderFns } from "./BackofficeActionButtons.vue?vue&type=template&id=25d020f2"
import script from "./BackofficeActionButtons.vue?vue&type=script&lang=ts"
export * from "./BackofficeActionButtons.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeActionButtons.vue?vue&type=style&index=0&id=25d020f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports